import script from "./ProfilePop.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePop.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilePop.vue?vue&type=style&index=0&id=2048daab&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2048daab"]])

export default __exports__